// extracted by mini-css-extract-plugin
export var wordContainer = "_ic-0";